import React from "react";
import { useState } from "react";
import emailjs from "emailjs-com";
import { Await } from "react-router-dom";
const ContactSection = () => {

  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   subject: "",
  //   message: "",
  // });
  // const [result, setResult] = React.useState("")
  // const [status, setStatus] = useState(null);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();          
  //   setResult("Sending....");
    // emailjs
    //   .sendForm(
    //     "service_rz0vruk", // EmailJS Service ID
    //     "template_exxbvpf", //EmailJS Template ID
    //     e.target,
    //     "79qjoEW9pqMcI2NAf" //EmailJS Public Key (User ID)
    //   )
    //   .then(
    //     (response) => {
    //       console.log("Email sent successfully:", response);
    //       setStatus("Message sent successfully!");
    //       setFormData({ name: "", email: "", subject: "", message: "" });
    //     },
    //     (error) => {
    //       console.log("Error sending email:", error);
         
    //     }
    //   );
  // };

    const [result, setResult] = React.useState("");

    const onSubmit = async (event) => {
      event.preventDefault();
      setResult("Sending....");
      const formData = new FormData(event.target);
  
      formData.append("access_key", "74d377fa-f31e-4f61-9b48-3cc619c83d7b");
  
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
  
      const data = await response.json();
  
      if (data.success) {
        setResult("Message sent successfully");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult(data.message);
      }
    };


  return (
    <section className="pt-5 contact-section">
      <div className="container  mb-4 text-left">
        <div className="row block-9">
          <div className="col-md-4 contact-info ">
            <div className="row">
              <div className="col-md-12 mb-4">
                <h2 className="h4 text-white">Contact Information</h2>
              </div>
              <div className="col-md-12 text-white">
                <p><span>Address :</span>  AUWM Compound Vengeri ,

Building No: 9/2467 (H4), Calicut / Kakkodi road, Calicut dist.</p>
              </div>
              <div className="col-md-12">
                <p><span>Phone :</span> <a className="primary-color" href="tel:00917510266377">+91 7510266377</a></p>
              </div>
              <div className="col-md-12">
                <p><span>Email :</span> <a className="primary-color" href="mailto:njsgroupwayanad@gmail.com ">njsgroupwayanad@gmail.com </a></p>
              </div>
             
            </div>
          </div>
          <div className="col-md-1"></div>
         
 <div className="col-md-6">
      <form className="contact-form" onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
             
              <input
                type="text"
                className="form-control"
                name="name"
                id="name"
                placeholder="Your Name"
             //   value={formData.name}
               // onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
           
              <input
                type="email"
                className="form-control"
                name="email"
                id="email"
                placeholder="Your Email"
             //   value={formData.email}
               // onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>
        <div className="form-group">
       
          <input
            type="text"
            className="form-control"
            name="subject"
            id="subject"
            placeholder="Subject"
          //  value={formData.subject}
           // onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
       
          <textarea
            className="form-control"
            name="message"
            id="message"
            cols="30"
            rows="3"
            placeholder="Message"
           // value={formData.message}
           // onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="form-group">
          <input
            type="submit"
            value="Send Message"
            className="rounded-0 btn btn-primary py-3 px-5"
          />
        </div>
        {result && <p>{result}</p>}
        {/* {status && <p>{status}</p>} */}
      </form>
    </div>
        </div>
      </div>
      <div className=" container mb-5">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d297833.33441475214!2d75.62300351883167!3d11.244180917967165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba65938563d4747%3A0x32150641ca32ecab!2sKozhikode%2C%20Kerala!5e0!3m2!1sen!2sin!4v1743142827747!5m2!1sen!2sin" frameborder="0" style={{width:3000, height:290}}
                 allowfullscreen="" className="img-fluid">
                 </iframe>
                </div>
    </section>
  );
};

export default ContactSection;





